/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSummary_user = {
    readonly emails: ReadonlyArray<string>;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryColorCategory_user" | "AutopilotFormSaveOnEdit_user">;
    readonly " $refType": "EventSummary_user";
};
export type EventSummary_user$data = EventSummary_user;
export type EventSummary_user$key = {
    readonly " $data"?: EventSummary_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummary_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSummary_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emails",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSummaryColorCategory_user"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AutopilotFormSaveOnEdit_user"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = '35bbe846c043a8abcc2908de6fbefbb6';
export default node;
